import type { ComponentProps } from 'react';

import { Button } from '@/lib/shadcn/button';
import { cn } from '@/lib/utils';

// Outlined secondary action button.
export function SecondaryButton({ className, ...props }: ComponentProps<typeof Button>) {
  return <Button variant="outline" className={cn(className)} {...props} />;
}
